import type { MouseEvent, ReactNode } from "react";
import type { IToastProps, IToastVariant } from "./types";
import { AlertTriangle, CheckCircle, Info, X, XCircle } from "lucide-react";
import { IconButton } from "../Button/IconButton";
import { clsx } from "clsx";
import { Typography } from "../Typography";
import { useBreakpoints } from "@/hooks/useBreakpoints";

export const ToastItem = ({
  variant = "info",
  title,
  message,
  onDismiss,
}: IToastProps) => {
  const { isMobile } = useBreakpoints();
  const iconMap: Record<IToastVariant, ReactNode> = {
    info: <Info size="1.5rem" />,
    success: <CheckCircle size="1.5rem" />,
    warning: <AlertTriangle size="1.5rem" />,
    error: <XCircle size="1.5rem" />,
  };

  const rootClass: string = clsx("nuco-toast", `nuco-toast--${variant}`);

  const handleDismiss = (e: MouseEvent) => {
    e.stopPropagation();
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className={rootClass}>
      <div className="nuco-toast__icon">{iconMap[variant]}</div>
      <div className="nuco-toast__details">
        {title && (
          <Typography
            as="div"
            className="nuco-toast__details-title"
            variant="body"
            weight="bold"
            text={title}
          />
        )}
        {message && (
          <Typography
            as="div"
            className="nuco-toast__details-message"
            variant="body"
            weight="regular"
            text={message}
          />
        )}
      </div>
      <div className="nuco-toast__actions">
        <IconButton
          size="sm"
          color={isMobile ? "layer1" : "layer2"}
          onClickCapture={handleDismiss}
          content={<X />}
        />
      </div>
    </div>
  );
};
